import React from "react";
import { Tooltip } from "antd";

const EllipsisWithTooltip = ({ text, maxLength = 60, type }) => {
  const shouldShowTooltip = text?.length > maxLength;
  const displayText = shouldShowTooltip
    ? text.slice(0, maxLength) + "..."
    : text;
  return (
    <Tooltip title={shouldShowTooltip ? text : ""}>
      {type === "link" && text ? (
        <a href={text}>{displayText || "N/A"}</a>
      ) : (
        <span>{displayText || "N/A"}</span>
      )}
    </Tooltip>
  );
};
export default EllipsisWithTooltip;
